import { useEffect, useState } from 'react'

import { IToolsCodeRules } from 'clickNgo/entities/contactFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

import { fetchToolsCodeRulesByType } from '../../api'

interface Params {
  type: ProfilingCodeType
}

export const useGetUserRightRules = ({ type }: Params) => {
  const [isLoading, setIsLoading] = useState(false)
  const [userRightRules, setUserRightRulesFlags] = useState<IToolsCodeRules[]>([])

  useEffect(() => {
    if (type === ProfilingCodeType.UserRights) {
      setIsLoading(true)
      fetchToolsCodeRulesByType(type, { cacheKey: 'useGetUserRightRules' })
        .then(setUserRightRulesFlags)
        .finally(() => setIsLoading(false))
    }
  }, [type])

  return { isLoading, userRightRules }
}
